var _excluded = ["selected"],
    _excluded2 = ["children", "selected", "counter", "icons", "disabled", "onToggle", "onClick", "theme"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { withTheme } from 'styled-components';
import { node, number, arrayOf, bool, func, oneOfType } from 'prop-types';
import { hexToRgb } from '@gympass/yoga-common';
import { theme } from '../../Theme';
import Icon from '../../Icon';
import Counter from './Counter';
var Text = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  box-sizing: border-box;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Wrapper = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  height: 32px;\n  max-width: 216px;\n\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n\n  border-style: solid;\n\n  cursor: pointer;\n\n  ", "\n"])), function (_ref) {
  var selected = _ref.selected,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _theme = theme(props),
      spacing = _theme.spacing,
      borders = _theme.borders,
      colors = _theme.colors,
      radii = _theme.radii,
      baseFont = _theme.baseFont,
      fontSizes = _theme.fontSizes,
      fontWeights = _theme.fontWeights,
      lineHeights = _theme.lineHeights;

  var commonStyles = "\n\n      padding: " + spacing.xxsmall + "px;\n\n      border-radius: " + radii.small + "px;\n      border-width: " + borders.small + "px;\n\n      font-family: " + baseFont.family + ";\n      font-size: " + fontSizes.xsmall + "px;\n      line-height: " + lineHeights.xsmall + "px;\n\n      :not(:last-child) {\n        margin-right: " + spacing.xxsmall + "px;\n      }\n\n      &[disabled] {\n        background-color: " + colors.elements.backgroundAndDisabled + ";\n        color: " + colors.elements.selectionAndIcons + ";\n\n        border-color: " + colors.elements.lineAndBorders + ";\n\n        cursor: not-allowed;\n      }\n\n      svg {\n        flex-shrink: 0;\n      }\n    ";

  if (selected) {
    return "\n        " + commonStyles + "\n\n        background-color: " + colors.yoga + ";\n        color: " + colors.primary + ";\n\n        border-color: transparent;\n\n        font-weight: " + fontWeights.medium + ";\n\n        &:hover:enabled {\n          border-color: " + colors.primary + ";\n        }\n      ";
  }

  return "\n      " + commonStyles + "\n\n      border-color: " + colors.elements.lineAndBorders + ";\n\n      background-color: " + colors.white + ";\n      color: " + colors.secondary + ";\n\n      font-weight: " + fontWeights.regular + ";\n\n      &:hover:enabled {\n        border-color: " + colors.secondary + ";\n      }\n\n      &:focus:enabled,\n      &:active:enabled {\n        border-color: " + hexToRgb(colors.elements.lineAndBorders, 0.75) + ";\n      }\n    ";
});
var Chips = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      selected = _ref2.selected,
      counter = _ref2.counter,
      icons = _ref2.icons,
      disabled = _ref2.disabled,
      onToggle = _ref2.onToggle,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? onToggle : _ref2$onClick,
      spacing = _ref2.theme.yoga.spacing,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var FirstIcon = icons[0],
      SecondIcon = icons[1];
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    selected: selected,
    disabled: disabled,
    onClick: onClick,
    ref: ref
  }, props), SecondIcon && /*#__PURE__*/React.createElement(Icon, {
    as: SecondIcon,
    fill: selected ? 'primary' : 'secondary',
    width: "small",
    height: "small",
    style: {
      marginRight: children ? spacing.xxxsmall : undefined
    }
  }), children && /*#__PURE__*/React.createElement(Text, null, children), selected && counter && !disabled && /*#__PURE__*/React.createElement(Counter, {
    value: counter
  }), FirstIcon && /*#__PURE__*/React.createElement(Icon, {
    as: FirstIcon,
    fill: selected ? 'primary' : 'secondary',
    width: "small",
    height: "small",
    style: {
      marginLeft: children ? spacing.xxxsmall : undefined
    }
  }));
});
Chips.propTypes = {
  /** text to be displayed */
  children: node,

  /** if the chip is selected */
  selected: bool,

  /** will display a three digit number, if the value is greater than 999 a plus
   * sign will be displayed instead. ex: "+999" */
  counter: number,

  /** disable chip */
  disabled: bool,

  /** a list of max two icons from @gympass/yoga-icons package */
  icons: arrayOf(oneOfType([node, func])),

  /** click event */
  onToggle: func,
  onClick: func
};
Chips.defaultProps = {
  children: undefined,
  selected: false,
  disabled: false,
  counter: undefined,
  icons: [],
  onToggle: undefined,
  onClick: undefined
};
export default withTheme(Chips);